import React, { useMemo } from 'react';
import moment from 'moment';
import dateFormatter from 'helpers/date_formatter';
import plural from 'helpers/plural';
import Button from './button';
import { useAngularService } from 'helpers/get_angular_service';

interface MessageStatusNoticeProps {
  item: any;
}

const MessageStatusNotice = ({ item }: MessageStatusNoticeProps) => {
  const ReactModal = useAngularService('ReactModal');
  const badges = item.data.badges;

  const openedBadge = useMemo(() => {
    if (!badges) return;
    return badges.find((item) => item.type === 'opened');
  }, [badges]);

  const spamBadge = useMemo(() => {
    if (!badges) return;
    return badges.find((item) => item.type === 'flagged_as_spam');
  }, [badges]);

  const timestamp = useMemo(() => {
    if (!openedBadge) return;
    return moment.utc(openedBadge.timestamp).local().format('YYYY-MM-DD HH:mm');
  }, [openedBadge]);

  const displayActivitySummary = () => {
    ReactModal.open({
      component: 'BulkMessageActivityDrawer',
      drawer: true,
      props: {
        logEntry: item,
      },
    });
  };

  return (
    <div>
      <div className="flex margin-top-8">
        {openedBadge && (
          <div>
            <span data-tip={`Email first read at: ${dateFormatter(timestamp, 'mediumDate')}`}>
              <i className="icon-preview" style={{ marginRight: '4px' }}></i>Opened{' '}
              {dateFormatter(timestamp, 'fromNow')}
            </span>
          </div>
        )}
        {spamBadge && (
          <div className="text-danger">
            <i className="icon-warning" style={{ marginRight: '4px' }}></i>This email was reported
            as spam by the recipient.
          </div>
        )}

        <div className="align-right">
          {item.data?.open_count > 0 && (
            <span
              className="margin-left-8"
              data-tip={`Email has been opened ${plural('time', item.data?.open_count, true)}`}
            >
              {item.data?.bulk_message ? (
                <Button variant="link" onClick={() => displayActivitySummary()}>
                  <i className="icon-preview" style={{ marginRight: '4px' }}></i>{' '}
                  {item.data.open_count}
                </Button>
              ) : (
                <span>
                  <i className="icon-preview" style={{ marginRight: '4px' }}></i>{' '}
                  {item.data.open_count}
                </span>
              )}
            </span>
          )}

          {item.data?.click_count > 0 && (
            <span
              className="margin-left-8"
              data-tip={`Link(s) in this email have been clicked ${plural(
                'time',
                item.data.click_count,
                true,
              )}`}
            >
              {item.data?.bulk_message ? (
                <Button variant="link" onClick={() => displayActivitySummary()}>
                  <i className="icon-link" style={{ marginRight: '4px' }}></i>{' '}
                  {item.data.click_count}
                </Button>
              ) : (
                <span>
                  <i className="icon-link" style={{ marginRight: '4px' }}></i>{' '}
                  {item.data.click_count}
                </span>
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageStatusNotice;
